var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userinfo"},[_c('app-header',{attrs:{"title":_vm.title}}),_c('form-entity',{staticClass:"form-edit",attrs:{"model":_vm.user,"rule":_vm.rule}},[_c('form-field',{attrs:{"prop":"nickname","default-focus":false,"options":{
        label: '用户昵称',
        readonly: true,
        placeholder: '用户昵称',
        type: 'text',
        required: true
      }}}),_c('form-field',{attrs:{"prop":"userID","default-focus":false,"options":{
        label: '用户ID',
        readonly: true,
        placeholder: '用户ID',
        type: 'text',
        required: true
      }}}),_c('form-field',{attrs:{"prop":"mobileNumber","options":{
        label: '手机号码',
        readonly: true,
        placeholder: '手机号码',
        type: 'tel',
        format: 'phone',
        required: true
      }}})],1),_c('img',{staticClass:"qrcode",attrs:{"src":_vm.info.data.adviser.erCode || '',"alt":""}}),_c('h5',[_vm._v(_vm._s(_vm.info.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }